export const prod = true;
// export const url = '//api.gamebox.i52wan.com';
export const url = '//api3.app.wakaifu.com';
// export const url = '//h5.api3.wakaifu.com';